import Api from "@/services/Api";

export default {
  uploadFiles(files) {
    return Api().post("/api/s3/upload", files)
  },
  getFileUrl(key) {
    return Api().get("/api/s3/?key=" + key)
  }
};